import { useEffect } from "react";
import { search } from "../../store/api/workItemsApi";
import { useDispatch, useSelector } from "react-redux";
import BihamtaTable from "../../../Components/BihamtaTable";
import { convertFromMoment } from "../../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fixDateFilters, getTableColumns } from "./helper";
import SearchFilters from "./SearchFilters";
import ExcelButton from "./ExcelButton";

export default function SearchAll({ type, isActive }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const filterData = useSelector(state => fixDateFilters(state.workItems.workItemsSearchFilters));

    const handleSearch = (data) => {
        if (data) {
            data.CreationDateFrom = convertFromMoment(data.CreationDateFrom).date;
            data.CreationDateTo = convertFromMoment(data.CreationDateTo).date;
        }
        dispatch(search({ ...data, Take: data?.Take ?? 10, Skip: data?.Skip ?? 0 }));
    }
    const gotoWi = (row) => {
        if (row.ctrlIsDown) {
            window.open(`/Projects/CreateEditWorkItem/false/${row.ID}`, '_blank');
        }
        else {
            history.push(`/Projects/CreateEditWorkItem/false/${row.ID}`);
        }
    }
    useEffect(() => {
        if (isActive)
            handleSearch(filterData);
    }, [type, isActive])

    return (
        <>
            <SearchFilters defaultValues={filterData} onSubmit={handleSearch} />
            <div style={{ display: "flex", justifyContent: "end" }}>
                <ExcelButton actionUrl="Search" filterData={filterData} tableCols={getTableColumns(type)} />
            </div>
            <BihamtaTable
                columns={getTableColumns(type)}
                className="mt-0"
                objectName="workItemsSearch"
                reducerName="workItems"
                filterData={filterData}
                rowClick={gotoWi}
                pageSizeList={[10, 20, 50, 100, 900]}
                hasPaging={true}
                searchMethod={data => dispatch(search(data))} />
        </>
    )
}